import { FontAwesomeIcon } from "@appcharge/shared-ui";

import { Popover } from "components/Popover";
import { Button } from "components/ui/button";

interface EvidenceActionMenuProps {
    evidenceId: string;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onDelete: (evidenceId: string) => void;
}

export const EvidenceActionMenu = ({ evidenceId, isOpen, onOpen, onClose, onDelete }: EvidenceActionMenuProps) => {
    return (
        <Popover
            isOpen={isOpen}
            onClose={onClose}
            position="bottom-right"
            trigger={
                <FontAwesomeIcon
                    icon="fa-regular fa-ellipsis-vertical !text-sm cursor-pointer"
                    onClick={onOpen}
                />
            }
        >
            <div>
                <Button
                    variant="text"
                    className="flex items-center gap-2 h-10 text-base-primary"
                    onClick={() => onDelete(evidenceId)}
                >
                    <FontAwesomeIcon icon="fa-regular fa-trash !text-sm" />
                    Delete Evidence
                </Button>
            </div>
        </Popover>
    );
};

